// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#other-user-group-type-list[data-v-7d400d8f]{max-width:1280px;margin-left:auto;margin-right:auto}#other-user-group-type-list .group-type-list-btn[data-v-7d400d8f]{width:80px}#other-user-group-type-list .back-btn[data-v-7d400d8f]{margin-left:12px;width:80px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
